var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficetel = function SvgOfficetel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 67,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#officetel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M30.807 1.306H1.448l-.002 67.8h39.261V8.667z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 6.676,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 6.676,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__b)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.032,
    y: 6.676,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.032,
    y: 6.676,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__c)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 17.322,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 17.322,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__d)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 17.32,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 17.32,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__e)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 27.965,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 27.965,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__f)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 27.965,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 27.965,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__g)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 38.611,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 38.611,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__h)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 38.609,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 38.609,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__i)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 49.258,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 6.678,
    y: 49.258,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__j)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("mask", {
    id: "officetel_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 49.258,
    rx: 0.71
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 7.097,
    x: 18.034,
    y: 49.258,
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    mask: "url(#officetel_svg__k)",
    rx: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M30.93 2v67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "officetel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v67H0z"
  })))));
};
export default SvgOfficetel;